import { LAYOUT_ROUTE } from "../../config";
import { LayoutContainerModel } from "../../models/containers/layout/LayoutContainerModel";
import { BaseRepository } from "../baseRepository";


const CONTAINER_ROUTE: string = LAYOUT_ROUTE + "/layoutcontainer";
const COUNT_CONTAINER_ROUTE: string = LAYOUT_ROUTE + "/countlayoutcontainers";
const PARTIAL_CONTAINER_ROUTE: string = LAYOUT_ROUTE + "/partiallayoutcontainer";

export class LayoutsRepository extends BaseRepository {
    public async listLayoutContainersWithRange(
        pageNumber: number,
        pageSize: number,
        position?: number,
        name?: string,
        tag?: string,
        pageId?: number,
        partial: boolean = false,
        descending: boolean = false

    ) : Promise<LayoutContainerModel[] | any> {
        const response = await this.api.get(
            (partial ? 
                PARTIAL_CONTAINER_ROUTE
                : 
                CONTAINER_ROUTE) + "s", {
            params: {
                position: position,
                name: name,
                tag: tag,
                pageId: pageId,
                pageNumber: pageNumber,
                pageSize: pageSize,
                descending: descending
            }
        });

        return response.data;
    }

    public async createLayoutContainer(
        model: LayoutContainerModel

    ) : Promise<any> {
        const response = await this.api.post(CONTAINER_ROUTE, model);
        return response.data;
    }

    public async updateLayoutContainer(
        model: LayoutContainerModel

    ) : Promise<any> {
        const response = await this.api.patch(CONTAINER_ROUTE, model);
        return response.data;
    }

    public async deleteLayoutContainer(
        id: number

    ) : Promise<any> {
        const response = await this.api.delete(CONTAINER_ROUTE + "/" + id);
        return response.data;
    }

    public async getLayoutContainer(
        position?: number,
        name?: string,
        tag?: string,
        pageId?: number,
        partial: boolean = false

    ) : Promise<LayoutContainerModel | any> {
        const response = await this.api.get(
            partial ? 
                PARTIAL_CONTAINER_ROUTE
                : 
                CONTAINER_ROUTE, {
            params: {
                position: position,
                name: name,
                tag: tag,
                pageId: pageId
            }
        });
        
        return response.data;
    }
    
    public async countLayoutContainersWithRange(
        pageNumber: number,
        pageSize: number,
        position?: number,
        name?: string,
        tag?: string,
        pageId?: number

    ) : Promise<number | any> {
        const response = await this.api.get(
            COUNT_CONTAINER_ROUTE, {
            params: {
                position: position,
                name: name,
                tag: tag,
                pageId: pageId,
                pageNumber: pageNumber,
                pageSize: pageSize
            }
        });

        return response.data;
    }
}